import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'twg-microsite.graphGrowth.heading',
		defaultMessage: 'Graph activity',
		description: 'Section heading above the weekly graph growth statistics',
	},
});
